import { render, staticRenderFns } from "./CreateCategoryPage.vue?vue&type=template&id=b6089076&"
import script from "./CreateCategoryPage.vue?vue&type=script&lang=js&"
export * from "./CreateCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports